import { render, staticRenderFns } from "./applyCertificate.vue?vue&type=template&id=30d67b3f&scoped=true"
import script from "./applyCertificate.vue?vue&type=script&lang=js"
export * from "./applyCertificate.vue?vue&type=script&lang=js"
import style0 from "./applyCertificate.vue?vue&type=style&index=0&id=30d67b3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d67b3f",
  null
  
)

export default component.exports